import Service, { getCallApiFunction } from '../service'
import { RecSource } from '@/methods/recommendTracking'

interface BodyType {
  productId: number
  visitorId?: string
  recSource?: RecSource // 從哪個推薦區塊點進來；不是從推薦點進來時不帶
}

// 記錄商品頁瀏覽（最近看過、看了也看、推薦成效）；後端記錄失敗也回成功，不影響商品頁
class RecordProductViewApi extends Service {
  constructor(data: BodyType) {
    super()
    this.name = 'RECORD_PRODUCT_VIEW'

    this.config = {
      url: `/v1/product/recommend/view`,
      method: 'POST',
      data,
    }
  }
}

export const recordProductView = (data: BodyType) => getCallApiFunction(new RecordProductViewApi(data))
